var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: [_vm.className, _vm.blockClass] }, [
    _c(
      "div",
      { class: `${_vm.blockClass}__text-container` },
      [
        _c(_vm.tag, { tag: "component", class: `${_vm.blockClass}__text` }, [
          _vm._v("\n            " + _vm._s(_vm.label) + "\n        "),
        ]),
        _vm._v(" "),
        _vm.$slots.actions
          ? _c(
              "div",
              { class: `${_vm.blockClass}__actions` },
              [_vm._t("actions")],
              2
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/components/SectionHeader.vue